@if (formControl()) {
<div class="checkbox form-group">
    <mat-form-field class="form-field">
        <input class="input-name" readonly matInput [value]="meta().name" [readonly]="meta().readonly || readonly()"
            hidden />
        <mat-checkbox matPrefix class="form-control input-checkbox" [formControl]="formControl()!"></mat-checkbox>
        <mat-hint><strong>{{meta().info}}</strong></mat-hint>
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
